import { Activity } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { PageShell } from '@/components/layout/PageShell'
import { CaseMonitor } from '@/features/monitor/CaseMonitor'
import { useCaseContext } from '../CaseContext'

export default function MonitorPage() {
  const { t } = useTranslation()
  const { caseId } = useCaseContext()
  return (
    <PageShell
      layout="full"
      icon={Activity}
      title={t('cases.monitor.title')}
      summary={t('cases.monitor.summary')}
    >
      <CaseMonitor caseId={caseId} />
    </PageShell>
  )
}
